// src/components/UI/DownloadCircleIcon.js
import React, { useId } from 'react';

// Brand-gradient circular download icon (single result card, Task History).
// useId keeps the gradient id unique when several render on one page.
const DownloadCircleIcon = ({ size = 26 }) => {
    const gradientId = `downloadCircleGradient-${useId()}`;
    return (
        <svg width={size} height={size} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect width="26" height="26" rx="13" fill={`url(#${gradientId})`} />
            <path d="M8 17.8848H17.77V19.1059H8V17.8848Z" fill="white" />
            <path d="M17.5931 12.213L16.7261 11.346L13.4963 14.5821V6.89453H12.2745V14.5821L9.04471 11.346L8.17773 12.213L12.8853 16.9144L17.5931 12.213Z" fill="white" />
            <defs>
                <linearGradient id={gradientId} x1="-9.68576e-08" y1="13" x2="23.8643" y2="26" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#2766AA" />
                    <stop offset="1" stopColor="#0752B0" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default DownloadCircleIcon;
